import { usePropertyField } from '../usePropertyField';
import { IApplicationNonRental } from '@apply/api/src/api/ApplyApi';

// ─── Bridge ───────────────────────────────────────────────────────────────────

export const usePropertyDevelopmentType = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.propertyDevelopmentType,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), propertyDevelopmentType: v } as IApplicationNonRental })
    );

export const usePropertyDevelopmentOther = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.propertyDevelopmentOther,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), propertyDevelopmentOther: v } as IApplicationNonRental })
    );

export const usePropertyOwnedThroughoutDevelopment = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.ownedThroughoutDevelopment,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), ownedThroughoutDevelopment: v } as IApplicationNonRental })
    );

export const usePropertyPreferredTermType = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.preferredTermType,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), preferredTermType: v } as IApplicationNonRental })
    );

export const usePropertyPreferredInterestPaymentType = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.preferredInterestPaymentType,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), preferredInterestPaymentType: v } as IApplicationNonRental })
    );

export const usePropertyCertificateOfOccupancy = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.certificateOfOccupancy,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), certificateOfOccupancy: v } as IApplicationNonRental })
    );

export const usePropertyWorkNeeded = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.workNeeded,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), workNeeded: v } as IApplicationNonRental })
    );

export const usePropertyWorkNeededDescription = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.workNeededDescription,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), workNeededDescription: v } as IApplicationNonRental })
    );

export const useExitType = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.exitType,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), exitType: v } as IApplicationNonRental })
    );

export const usePropertyExpectedTakeOutLoanAmount = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.expectedTakeOutLoanAmount,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), expectedTakeOutLoanAmount: v } as IApplicationNonRental })
    );
